import { APPLICATION_ROUTES } from "../../shared-logic/routes";

export const getCollectionUrl = (authorSlug: string, isMainDomain: boolean, collectionSlug: string, smartShareUrl?: string) => {
    const computedAuthorSlug = isMainDomain ? authorSlug : "";

    if (!!smartShareUrl) {
        return APPLICATION_ROUTES.SMART_SHARE_PROFILE_COLLECTION_PAGE.replace("[author]", computedAuthorSlug)
            .replace("[collectionAccessKey]", collectionSlug)
            .replace("[smartShareURL]", smartShareUrl);
    } else {
        return APPLICATION_ROUTES.PROFILE_COLLECTION_PAGE.replace("[author]", computedAuthorSlug).replace("[collectionAccessKey]", collectionSlug);
    }
};
